var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgXCircle = function SvgXCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Component 58 \\u2013 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2182",
    d: "m9.867 6.124-3.74 3.737",
    fill: "none",
    stroke: "#7b838f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2183",
    d: "M9.872 9.867 6.128 6.123",
    fill: "none",
    stroke: "#7b838f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 49",
    fill: "none",
    stroke: "#7b838f",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.4
  }))));
};
export default SvgXCircle;